import React, { Component } from 'react';
import { connect } from 'react-redux';
import { get, isEmpty } from 'lodash';
import { CheckboxUnlabeled } from '../../../../common/components/ReduxFormField';
import { Field, reduxForm, getFormValues, Form } from 'redux-form';
import { Col, Row, ControlLabel, FormGroup } from 'react-bootstrap';
import 'moment/locale/en-gb';
import '../CampaignNewForm/styles.scss';
import { triggerFileUpload } from '../../../../common/components/Upload/UploadRedux';
import {
  Box,
  Button,
  ButtonBar,
  DatePickerDob,
  HorizontalFormControl,
} from '../../../../common/components';
import SelectField from '../../../../common/components/ReduxFormField/SelectField';
import Select from 'react-select';
import moment from 'moment';
import CampaignBannerModal from '../CampaignBannerModal/CampaignBannerModal';
import BannerPreview from '../BannerPreview/BannerPreview';
import getIncludedResource from '../../../../helpers/getIncludedResource';
import InfoButton from '../../../../common/components/InfoButton/InfoButton';
import { numericality, required } from 'redux-form-validators';
import selectTheme from '../../../../helpers/selectTheme';
import FormGroupRow from '../../../../common/components/FormGroupRow/FormGroupRow';
import AsyncMultiSelectMenu from '../../../../common/components/SelectMenu/AsyncMultiSelectMenu';
import SelectMenu from '../../../../common/components/SelectMenu/SelectMenu';

const isNumeric = numericality({ message: 'Must be a Number', allowBlank: true });
const isRequired = required({ message: 'Required' });
const parseInteger = (value) => {
  return !isFinite(parseInt(value)) ? value : parseInt(value);
};

const startDateValid = (value, formValues) => {
  const todayDate = moment().format();
  const formDate = get(formValues, 'data.attributes.to_date');
  const checkDatesDiff = moment(formDate).isBefore(todayDate);
  //End date should be later than current date
  return checkDatesDiff ? 'Update is required' : undefined;
};

const templateDefaults = {
  id: null,
  type: 'templates',
  attributes: {
    name: '',
    slug: '',
    sections: {},
  },
};

class CampaignEditForm extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      brokerType: null,
      template: templateDefaults,
      destinationOptions: getDestinations,
      familyOptions: getFamilyGroup,
    };
  }

  componentDidMount() {
    const { dispatch, change, resource } = this.props;
    dispatch(change('data.attributes.meta.type_option', 'campaign'));
    const includedBrokers = getIncludedResource(
      resource.data,
      resource.included,
      'brokers',
    );
    const brokers = Array.isArray(includedBrokers) ? includedBrokers : [];


    const hasTrackingBroker = brokers.some((element) => {
      return element.attributes.broker_type === 'tracking';
    });
    if (!isEmpty(brokers) && hasTrackingBroker) {
      this.setState({
        brokerType: 'tracking',
      });
    }
    if (!isEmpty(brokers) && !hasTrackingBroker) {
      this.setState({
        brokerType: 'broker',
      });
    }
  }

  handleSchemeTypeChange(schemeType) {
    if (!schemeType) {
      this.setState(() => ({
        destinationOptions: getDestinations,
      }));
    } else {
      this.setState(() => ({
        destinationOptions:
          schemeType === 'annual' ? getDestinationsAnnual : getDestinationsSingle,
      }));
    }
  }

  handleUpload() {
    const { dispatch } = this.props;
    dispatch(triggerFileUpload());
  }

  handleUploadComplete(data) {
    const { dispatch, change } = this.props;

    dispatch(change('data.relationships.avatar.data', data.data));
  }

  handleChangeBrokerType(option) {
    const { dispatch, change } = this.props;
    dispatch(change('data.relationships.brokers.data', []));
    this.setState({
      brokerType: option ? option.value : null,
    });
  }

  renderField = (field) => {
    const { input, type, meta } = field;
    const className =
      meta.submitFailed && !meta.pristine && meta.error && meta.error.length > 0
        ? 'form-control has-error'
        : 'form-control';
    return (
      <div>
        <input disabled={field.disabled} {...input} className={className} type={type} />
        <span className="input-error">{meta.error}</span>
      </div>
    );
  };

  render() {
    const { formValues, handleSubmit, updateCampaign } = this.props;
    const { brokerType } = this.state;
    const resource = this.props.resource.data.attributes;
    const selected = resource.campaign_type;
    const uppercase = (value) => value && value.toUpperCase();
    const code = get(formValues, 'data.attributes.code');
    const discount = get(formValues, 'data.attributes.discount');
    const bannerText = get(formValues, 'data.attributes.metadata.banner.banner_text');
    const discountMessage = get(
      formValues,
      'data.attributes.metadata.banner.discount_message',
    );
    const whereToApply = get(formValues, 'data.attributes.metadata.banner.banner_info');
    const page = get(formValues, 'data.attributes.metadata.banner.page');
    const timeIdle = get(formValues, 'data.attributes.metadata.banner.time_idle');
    const bannerImage = get(formValues, 'data.attributes.metadata.banner.files.data');
    const bannerEnabled = get(formValues, 'data.attributes.metadata.banner.enabled');
    const bannerPhone = get(formValues, 'data.attributes.metadata.banner.phone');

    const brokers = get(formValues, 'data.relationships.brokers');
    const channels = getIncludedResource(
      this.props.resource.data,
      this.props.resource.included,
      'channels',
    );

    const showPublicOption = channels.some((channel) =>
      ['B2C', 'B2B'].includes(channel.attributes.channel_type),
    );
    return (
      <div>
        <Box>
          <h4 className="title-campaign">Edit {selected}</h4>
          <hr id="first-row" />
          <Form onSubmit={handleSubmit(updateCampaign)}>
            <Row>
              <Col sm={6}>
                <Field
                  name="data.attributes.name"
                  label="Name"
                  labelSize={4}
                  component={HorizontalFormControl}
                  validate={[isRequired]}
                />
                {selected === 'Campaign' && (
                  <Field
                    name="data.attributes.code"
                    normalize={uppercase}
                    label="Voucher Code"
                    labelSize={4}
                    component={HorizontalFormControl}
                    validate={[isRequired]}
                  />
                )}
                <Field
                  name="data.attributes.has_url"
                  label={<strong>Has url?</strong>}
                  component={CheckboxUnlabeled}
                  inline
                  labelSize={4}
                  options={[{ label: '', value: true }]}
                />
              </Col>

              <Col sm={6}>
                {selected === 'Campaign' && (
                  <Field
                    name="data.attributes.discount"
                    label="Discount"
                    labelSize={4}
                    fieldSize={3}
                    addonAfter={'%'}
                    showError
                    component={HorizontalFormControl}
                    validate={[isRequired, isNumeric]}
                  />
                )}
                {selected === 'Commission Adjustment' && (
                  <Field
                    name="data.attributes.premium_overrides.commission_rate"
                    label="Commission Rate"
                    labelSize={4}
                    fieldSize={3}
                    addonAfter={'%'}
                    validate={[isNumeric]}
                    component={HorizontalFormControl}
                  />
                )}
                <Field
                  name="data.attributes.exclusive"
                  label={<strong>Exclusive</strong>}
                  component={CheckboxUnlabeled}
                  inline
                  labelSize={4}
                  options={[{ label: '', value: true }]}
                />
                <Field
                  name="data.attributes.from_date"
                  label="Start Date"
                  labelSize={4}
                  fieldSize={7}
                  component={DatePickerDob}
                  validate={[isRequired, startDateValid]}
                />
                <Field
                  name="data.attributes.to_date"
                  label="End Date"
                  labelSize={4}
                  fieldSize={7}
                  component={DatePickerDob}
                />
              </Col>
            </Row>
            <hr id="second-row" />
            <Row>
              <Col sm={6}>
                <FormGroupRow label="Product" labelSize={4}>
                  <Field
                    name="data.relationships.product.data.id"
                    component={SelectMenu}
                    optionValuePath={'id'}
                    source={'products'}
                    isClearable
                  />
                </FormGroupRow>
                {showPublicOption && (
                  <Field
                    name="data.attributes.is_public"
                    infoButton={
                      <InfoButton
                        content={'Do you want the campaign to apply on the public site?'}
                      />
                    }
                    component={CheckboxUnlabeled}
                    inline
                    options={[{ label: '', value: true }]}
                  />
                )}

                <FormGroup>
                  <Col sm={4}>
                    <ControlLabel>Broker / Tracking Link</ControlLabel>
                  </Col>
                  <Col sm={8}>
                    <Select
                      theme={(theme) => selectTheme(theme)}
                      options={brokerTypes}
                      placeholder={'Please Select...'}
                      onChange={(option) => this.handleChangeBrokerType(option)}
                      value={brokerTypes.find((bt) => {
                        return bt.value === brokerType;
                      })}
                    />
                  </Col>
                </FormGroup>

                {brokerType === 'tracking' && (
                  <FormGroupRow label="Tracking Links" labelSize={4}>
                    <Field
                      name="data.relationships.brokers.data"
                      key={'brokers' + brokerType}
                      filters={[{ type: 'broker_type', match: 'tracking' }]}
                      url={'/brokers?'}
                      preSelectedOptions={getIncludedResource(
                        formValues.data,
                        formValues.included,
                        'brokers',
                      )}
                      component={AsyncMultiSelectMenu}
                    />
                  </FormGroupRow>
                )}
                {brokerType === 'broker' && (
                  <FormGroupRow label="Brokers" labelSize={4}>
                    <Field
                      name="data.relationships.brokers.data"
                      key={'brokers' + brokerType}
                      filters={[{ type: 'broker_type', match: 'broker' }]}
                      url={'/brokers?'}
                      //preSelectedOptions={getIncludedResource(formValues.data, formValues.included, 'brokers')}
                      component={AsyncMultiSelectMenu}
                    />
                  </FormGroupRow>
                )}
              </Col>
              <Col sm={6}>
                <FormGroupRow label="Channels" labelSize={4}>
                  <Field
                    name="data.relationships.channels.data"
                    url={'/channels?'}
                    isClearable
                    preSelectedOptions={channels ? channels : null}
                    component={AsyncMultiSelectMenu}
                  />
                </FormGroupRow>
                <Field
                  name="data.attributes.criterion.scheme_type.equal"
                  label="Scheme Type"
                  labelSize={4}
                  options={schemeLevel}
                  onChange={(event, option) => this.handleSchemeTypeChange(option)}
                  component={SelectField}
                />

                <Field
                  name="data.attributes.criterion.cover_level.equal"
                  label="Cover Level"
                  labelSize={4}
                  options={coverLevel}
                  component={SelectField}
                />

                {/*<Field*/}
                {/*name='data.relationships.insurer.data.id'*/}
                {/*label='Brand'*/}
                {/*labelSize={4}*/}
                {/*component={SelectInsurer}*/}
                {/*/>*/}
              </Col>
            </Row>
            <hr id="third-row-banner" />
            <Row>
              <Col sm={6}>
                <Field
                  label="Family Group"
                  labelSize={4}
                  name="data.attributes.criterion.traveller_group.in"
                  component={SelectField}
                  isMulti
                  options={getFamilyGroup}
                />
                <Field
                  label="Regions"
                  labelSize={4}
                  name="data.attributes.criterion.region.in"
                  component={SelectField}
                  isMulti
                  options={this.state.destinationOptions}
                />
              </Col>
              <Col sm={6}>
                <FormGroup controlId="age">
                  <Col componentClass={ControlLabel} sm={4}>
                    Target Ages
                  </Col>
                  <Col sm={3}>
                    <Field
                      name="data.attributes.criterion.min_age.min"
                      type="text"
                      id="ageStart"
                      component={this.renderField}
                      validate={[isNumeric]}
                      parse={(value) => (!value ? null : parseInteger(value))}
                    />
                  </Col>
                  <Col sm={1}>
                    <p className="text-adjust">to</p>
                  </Col>
                  <Col sm={3}>
                    <Field
                      name="data.attributes.criterion.max_age.max"
                      type="text"
                      id="ageEnd"
                      component={this.renderField}
                      validate={[isNumeric]}
                      parse={(value) => (!value ? null : parseInteger(value))}
                    />
                  </Col>
                </FormGroup>
                <FormGroup controlId="range-fields">
                  <Col componentClass={ControlLabel} sm={4}>
                    Target Duration
                  </Col>
                  <Col sm={3}>
                    <Field
                      name="data.attributes.criterion.duration.min"
                      component={this.renderField}
                      validate={[isNumeric]}
                      parse={(value) => (!value ? null : parseInteger(value))}
                    />
                  </Col>
                  <Col sm={1}>
                    <p className="text-adjust">to</p>
                  </Col>
                  <Col sm={3}>
                    <Field
                      name="data.attributes.criterion.duration.max"
                      type="text"
                      component={this.renderField}
                      validate={[isNumeric]}
                      parse={(value) => (!value ? null : parseInteger(value))}
                    />
                  </Col>
                </FormGroup>
                <FormGroup controlId="">
                  <Col componentClass={ControlLabel} sm={4}>
                    Target Healix Scores
                  </Col>
                  <Col sm={3}>
                    <Field
                      name="data.attributes.criterion.max_score.min"
                      validate={[isNumeric]}
                      parse={(value) => (!value ? null : parseInteger(value))}
                      id="healixStart"
                      component={this.renderField}
                    />
                  </Col>
                  <Col sm={1}>
                    <p className="text-adjust">to</p>
                  </Col>
                  <Col sm={3}>
                    <Field
                      name="data.attributes.criterion.max_score.max"
                      validate={[isNumeric]}
                      parse={(value) => (!value ? null : parseInteger(value))}
                      id="healixStart"
                      component={this.renderField}
                    />
                  </Col>
                </FormGroup>
              </Col>
            </Row>
            {get(formValues, 'data.attributes.metadata.banner') && (
              <Row>
                {bannerImage && code && discount && (
                  <Col sm={12}>
                    <hr id="second-row" />
                    <p>Banner</p>
                    <div className="form-horizontal">
                      <Field
                        name="data.attributes.metadata.banner.enabled"
                        label={<strong>Enable Campaign Banner?</strong>}
                        component={CheckboxUnlabeled}
                        positionTop
                        inline
                        labelSize={4}
                        options={[{ label: '', value: true }]}
                      />
                    </div>
                    <Col
                      md={12}
                      sm={12}
                      xs={12}
                      className={`preview-banner-container ${!bannerEnabled &&
                        'disabled'}`}
                    >
                      <BannerPreview
                        code={code}
                        discount={discount}
                        bannerText={bannerText}
                        discountMessage={discountMessage}
                        whereToApply={whereToApply}
                        page={page}
                        timeIdle={timeIdle}
                        bannerImage={bannerImage}
                        bannerPhone={bannerPhone}
                        {...this.props}
                      />
                    </Col>
                  </Col>
                )}
              </Row>
            )}
            <ButtonBar>
              <Button
                size="large"
                type="submit"
                className="pull-right pad-right"
                label="Save"
                bsStyle="primary"
              />
              <CampaignBannerModal
                code={code}
                discount={discount}
                bannerText={bannerText}
                discountMessage={discountMessage}
                whereToApply={whereToApply}
                page={page}
                timeIdle={timeIdle}
                bannerImage={bannerImage}
                bannerEnabled={bannerEnabled}
                brokerType={brokerType}
                brokers={brokers}
                channels={channels}
                bannerPhone={bannerPhone}
                {...this.props}
              />
            </ButtonBar>
          </Form>
        </Box>
      </div>
    );
  }
}

const getDestinationsSingle = [
  { label: 'UK', value: 'uk' },
  { label: 'Europe Excluding', value: 'europe_excluding' },
  { label: 'Europe', value: 'europe' },
  { label: 'Worldwide Excluding', value: 'worldwide_excluding' },
  { label: 'Worldwide', value: 'worldwide' },
];
const getDestinationsAnnual = [
  { label: 'Europe', value: 'europe' },
  { label: 'Worldwide', value: 'worldwide' },
];

const getDestinations = [
  { label: 'UK', value: 'UK' },
  { label: 'EU1', value: 'europe' },
  { label: 'EU2', value: 'europe_excluding' },
  { label: 'WW', value: 'worldwide' },
  { label: 'WW1', value: 'worldwide_excluding' },
  { label: 'WW2', value: 'worldwide_including' },
];

const getFamilyGroup = [
  { label: 'Individuals', value: 'individual' },
  { label: 'Couple', value: 'couple' },
  { label: 'Family', value: 'family' },
];
const coverLevel = [
  { label: 'Bronze', value: 'Bronze' },
  { label: 'Silver', value: 'Silver' },
  { label: 'Gold', value: 'Gold' },
];

const schemeLevel = [
  { label: 'Annual', value: 'annual' },
  { label: 'Single', value: 'single' },
];

const brokerTypes = [
  { label: 'Tracking Link', value: 'tracking' },
  { label: 'Broker', value: 'broker' },
];
const FORM_NAME = 'campaignEditForm';
const form = reduxForm({ form: FORM_NAME })(CampaignEditForm);
const mapStateToProps = (state, props) => {
  return {
    initialValues: props.resource,
    formValues: getFormValues(FORM_NAME)(state),
  };
};

export default connect(mapStateToProps)(form);
